import React from 'react';
import { SectionFieldCollection, SectionFieldDTO } from '../magic-report.type';
import { MagicReportSection } from './MagicReportSection';
import { PROJECT_DESCRIPTION_SECTION_CONFIG } from './sections.config';
import { DeclarativeLayoutRenderer } from './DeclarativeLayoutRenderer';

interface ProjectDescriptionSectionProps {
  magicReportId: string;
}

/**
 * Project Description Section Content
 * A single free-text paragraph field. No Comments section and not bookmarkable as an action item.
 */
const ProjectDescriptionSectionContent: React.FC<{
  getField: (fieldName: string) => SectionFieldDTO | undefined;
  handleFieldChange: (fieldName: string, updates: Partial<SectionFieldDTO>) => void;
}> = ({ getField, handleFieldChange }) => {
  if (!PROJECT_DESCRIPTION_SECTION_CONFIG.layout) {
    return <div>Layout configuration missing</div>;
  }

  return (
    <DeclarativeLayoutRenderer
      layout={PROJECT_DESCRIPTION_SECTION_CONFIG.layout}
      getField={getField}
      handleFieldChange={handleFieldChange}
    />
  );
};

/**
 * Project Description Section
 * Fully config-driven — layout is defined in sections.config.ts
 */
export const ProjectDescriptionSection: React.FC<ProjectDescriptionSectionProps> = ({ magicReportId }) => {
  return (
    <MagicReportSection
      magicReportId={magicReportId}
      sectionConfig={PROJECT_DESCRIPTION_SECTION_CONFIG}
      customization={{
        renderContent: (_data: SectionFieldCollection, handleFieldChange, getField) => (
          <ProjectDescriptionSectionContent getField={getField} handleFieldChange={handleFieldChange} />
        ),
      }}
    />
  );
};
